@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: repeater from "../../styles/layout.module.scss";
    grid-column: margin;
    padding-top: var(--spacer-24);
}

.list {
    composes: inherit from "../../styles/layout.module.scss";
    composes: listReset from "../../styles/utils.module.scss";
    composes: fontST14 from "../../styles/typography.module.scss";

    > li {
        display: inline;

        @media ($below-mobile) {
            &:not(:nth-last-of-type(2)) {
                display: none;
            }
        }
    }

    [role="separator"] {
        color: currentColor;
        margin-inline: var(--spacer-8);

        @media ($below-mobile) {
            display: none;
        }
    }

    svg {
        width: 1em;
        rotate: 180deg;
        vertical-align: middle;
        color: currentColor;
        margin-right: var(--spacer-8);

        @media ($above-mobile) {
            display: none;
        }
    }
}
